<template>
  <el-container style="height: 100%">
<!--    <el-header>
      &lt;!&ndash;导航菜单&ndash;&gt;
&lt;!&ndash;      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
        <el-menu-item index="/orders">订单管理</el-menu-item>
        &lt;!&ndash;        <el-menu-item index="/users">用户管理</el-menu-item>&ndash;&gt;
      </el-menu>&ndash;&gt;
    </el-header>-->
    <el-main>
      <el-row >
        <el-col :span="24">
          <span>订单列表</span>
          <el-divider direction="vertical"></el-divider>
          <el-button style="margin:10px 0px;" @click="handleEdit(null, null,'添加')" type="success" size="mini">添加</el-button>
          <el-table
            :data="tableData.filter(data => !search || data.orderNr.toLowerCase().includes(search.toLowerCase()))"
            highlight-current-row
            @current-change="handleCurrentChange"
            @row-dblclick="showStatus"
            @filter-change="reGetList"
            style="width: 100%;">
            <el-table-column label="订单编号" prop="orderNr"></el-table-column>
            <el-table-column label="备注" prop="brief"></el-table-column>
            <el-table-column label="创建时间" prop="createTime"></el-table-column>
            <el-table-column label="修改时间" prop="updateTime"></el-table-column>
            <el-table-column label="状态个数" prop="status"></el-table-column>
            <el-table-column label="所属人员" prop="userName"></el-table-column>
            <el-table-column label="已完成" prop="finished" :formatter="formatStatus"  column-key="filterTag"
            :filters="[{text: '完成', value: true}, {text: '未完成', value: false}]" :filter-method="filterStatus" :filtered-value="[false]"></el-table-column>
            <el-table-column align="right" width="500">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="search"
                  size="mini"
                  placeholder="输入订单编号的关键字进行搜索"/>
              </template>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                    @click="createQueryLink(scope.$index, scope.row)">生成查询链接
                </el-button>
                <el-button
                  size="mini"
                  :disabled="scope.row.finished"
                    @click="finish(scope.$index, scope.row)">完成
                </el-button>
                <el-button
                  size="mini"
                    @click="handleEdit(scope.$index, scope.row,'编辑')">编辑
                </el-button>
                <el-popconfirm
                  confirmButtonText='好的'
                  cancelButtonText='不用了'
                  icon="el-icon-info"
                  iconColor="red"
                  title="确定要删除当前订单吗？"
                  @onConfirm="handleDelete('/orders/deleteById?id=',scope.$index, scope.row)"
                >
                  <el-button size="mini"
                             type="danger"
                             slot="reference">删除
                  </el-button>
                </el-popconfirm>
                <el-button
                  size="mini"
                  @click="addStatus(scope.$index, scope.row)">添加状态
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <Pagination
            v-if="total > 0"
            :total="total"
            :page.sync="page"
            :limit.sync="pageSize"
            @pagination="getPagination"
        ></Pagination>
          <!-- <el-row>
            <el-col :span="12" :offset="12">
              <el-pagination style="margin: 15px 0px;"
                             background
                             prev-text="上一页"
                             next-text="下一页"
                             layout="prev, pager, next,jumper,total,sizes"
                             :page-size="size"
                             :current-page.sync="pageNow"
                             :page-sizes="[5,10,15,20,25]"
                             @current-change="findPage"
                             @size-change="findSize"
                             :total="total">
              </el-pagination>
            </el-col>
          </el-row> -->
        </el-col>
      </el-row>

      <el-dialog title="订单信息" :visible.sync="orderDialogFormVisible">
        <el-form :hide-required-asterisk="false" :rules="rules" ref="userForm" :model="form" label-suffix=":"
                 label-width="auto">
          <el-form-item label="订单编号" prop="orderNr">
            <el-input type="textarea" v-model="form.orderNr"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="brief">
            <el-input type="textarea" v-model="form.brief"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('userForm',form,'/orders/saveOrUpdate')">保存信息</el-button>
            <el-button @click="saveUserInfo">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog title="状态信息" :visible.sync="statusDialogFormVisible">
        <el-form :hide-required-asterisk="false" :rules="rules" ref="statusForm" :model="statusForm" label-suffix=":"
                 label-width="auto">
          <el-form-item label="跟踪信息" prop="brief">
            <el-input type="textarea" v-model="statusForm.brief"></el-input>
          </el-form-item>
          <el-form-item label="更新时间" prop="updateTime">
            <el-date-picker
              v-model="statusForm.updateTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('statusForm',statusForm,'/status/saveOrUpdate')">保存信息</el-button>
            <el-button @click="saveUserInfo">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog title="物流状态" :visible.sync="statusDialogVisible">
        <el-table :data="statusData">
          <el-table-column property="brief" label="跟踪信息" ></el-table-column>
          <el-table-column property="updateTime" label="更新时间" ></el-table-column>
          <el-table-column align="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="addStatus(scope.$index, scope.row,'编辑')">编辑
              </el-button>
              <el-popconfirm
                confirmButtonText='好的'
                cancelButtonText='不用了'
                icon="el-icon-info"
                iconColor="red"
                title="确定要删除当前状态吗？"
                @onConfirm="handleDelete('/status/deleteById?id=',scope.$index, scope.row)"
              >
                <el-button size="mini"
                           type="danger"
                           slot="reference">删除
                </el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

    </el-main>
  </el-container>
</template>

<script>
import Pagination from '../pagination.vue'
export default {
  name: "List",
  components:{Pagination},
  data() {
    return {
      tableData: [],
      search: '',
      show: false,
      form: {
        orderNr: '',
        brief:'',
        createTime: '',
        updateTime: '',
        status: '',
        speed: '',
        userId: '',
        userName: '',
      },
      statusData:[],
      statusForm:{
        id:'',
        brief:'',
        updateTime: '',
        orderId:'',
        finished:true
      },
      filter:false,
      orderDialogFormVisible: false,
      statusDialogFormVisible: false,
      statusDialogVisible: false,
      total: 0,
      pageSize: 20,
      page: 1,
      rules: {
        orderNr: [
          {required: true, message: '请输入订单号!', trigger: 'blur'},
        ],
        brief: [
          {required: true, message: '请输入跟踪信息!', trigger: 'blur'},
        ],
        updateTime: [
          {required: true, message: '请输入更新日期!', trigger: 'blur'},
        ]
      }
    }
  },
  computed: {
    filteredData() {
      return this.tableData.filter(item => this.filterStatus(item.status));
    }
  },
  created() {
    this.findAllTableData();
  },
  methods: {
    createQueryLink(index, row){
        alert("http://logistics.yuncargo.cn/#/status?orderNr="+row.orderNr);
    },
    getPagination(param){
      // this.findAllTableData(param.page,param.limit);  
      this.findAllTableData();
    },
    reGetList(column){
      let size = column.filterTag.length;
      if(size>1){
        this.filter = ''
      }else{
        this.filter = column.filterTag[0]
      }
      this.findAllTableData()
    },
    formatStatus(row, column, cellValue) {
    return cellValue ? '完成' : '未完成';
    },
    filterStatus(value, row, column) {
    return row.finished === value;
    },
    findSize(size) { //用来处理每页显示记录发生变化的方法
      this.size = size;
      this.findAllTableData(this.page,size);
    },
    findPage(page) {//用来处理分页相关方法
      this.page = page;
      this.findAllTableData(page, this.size);
    },
    saveUserInfo() {//点击添加时清空信息
      this.show = true;
      this.form = {sex: '男'};
    },
    handleEdit(index, row,title) {
      let _this = this
      this.orderDialogFormVisible = true;//展示编辑表单
      if(row!=null&&title==="编辑"){
        this.form = JSON.parse(JSON.stringify(row));//回显编辑信息
      }else {
        this.form = {},
        this.$http.get("/findByName?userName="+localStorage.getItem("token")).then(res => {
          _this.form.userId= res.data.data.id;
          _this.form.userName= res.data.data.name;
        })
      }
    },
    finish(index, row) {
      let _this = this
      this.$http.post("/orders/finish",row).then(res => {
       this.findAllTableData();
      })
    },
    addStatus(index, row,title) {
      let _this = this;
      this.statusDialogFormVisible = true;//展示编辑表单
      if(row!=null&&title==="编辑"){
        this.statusForm= JSON.parse(JSON.stringify(row));
      }else {
        this.statusForm= {};
        this.statusForm.orderId = row.id;
      }
    },
    showStatus(index, row,orderNr) {
      if(index!=null){
        if(index.status==0){
          return;
        }
        orderNr = index.orderNr
      }
      this.$http.get("status/findByOrder?orderNr=" + orderNr).then(res => {
        if (res.data.code === 200) {
          this.statusData = res.data.data
          this.statusDialogVisible = true;//展示编辑表单
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    handleDelete(url,index, row) {
      //发送axios请求处理删除
      this.$http.get(url + row.id).then(res => {
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
          this.findAllTableData();//刷新数据
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    onSubmit(userForm,dataForm,url) {
      this.$refs[userForm].validate((valid) => {
        if (valid) {
          //发送一个ajax请求
          this.$http.post(url,dataForm).then(res => {
            if (res.data.code ===200) {
              this.$message({
                message: '恭喜你，' + res.data.msg,
                type: 'success'
              });
              //清空表单信息
              this.form = {};
              this.statusform = {};
              this.orderDialogFormVisible = false
              this.statusDialogFormVisible = false
              this.statusDialogVisible = false
              //调用刷新数据的方法
              this.findAllTableData();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          this.$message.error("当前输入的数据不合法!!!");
          return false;
        }
      });
    },
    findAllTableData(page,pageSize) {
    //   page = page?page:this.page
    //   pageSize = pageSize? pageSize:this.pageSize
    if(this.filter === ''){
      this.$http.get("/orders/findByPage?page="+this.page+"&pageSize="+this.pageSize).then(res => {
      this.tableData = res.data.users;
      this.total = res.data.total;
      });
    }else{
      this.$http.get("/orders/findByPageAndFinish?page="+this.page+"&pageSize="+this.pageSize+"&filter="+this.filter).then(res => {
      console.log(res.data.users)
      console.log( res.data.total)
      this.tableData = res.data.users;
      this.total = res.data.total;
      });
    }
    },
    // findAllTableData() {
    //     this.$http.post("/orders/findAll/").then(res => {
    //     console.log(res.data.users)
    //     this.tableData = res.data.users;
    //     this.total = this.tableData.length;
    //   });
    // },
    handleCurrentChange(val) {
      this.currentRow = val;
    },formatBoolean: function (row, index) {
      let ret = ''
      if (row.finished == true) {
        ret = "完成" //根据自己的需求设定
      } else {
        ret = "未完成"
      }
      return ret;
    },
  },
  
  beforeCreate: function () {
    let item = localStorage.getItem("token");
    if(item == null||item==undefined){
      this.$router.push('/login')
    }
  },

}
</script>

<style scoped>
.my-pagination { position: fixed; bottom: 0; left: 0; right: 0; }
/* .el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
} */
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.el-table__header th:nth-child(7) {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/order/OrderList.vue